export const SUBSCRIPTION_STATUS = {
  ACTIVE: 0,
  CANCELLED: 1,
  NON_RENEWING: 2,
};
